import { Carousel, Typography } from 'antd';
import { useContext, useRef } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { DashboardContext } from '..';
import Nudge from '../../../Models/Nudge';
import styles from './index.module.css';
import NudgeItem from './NudgeItem';

const Nudges: React.FC<{
  nudgeList: Nudge[];
  onViewAll?: () => void;
}> = ({ nudgeList, onViewAll }) => {
  const { onNudgeClick }: any = useContext(DashboardContext);
  const carouselRef = useRef<any>(null);

  if (nudgeList.length === 0) {
    return null;
  }

  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  if (nudgeList.length === 1) {
    return (
      <div className={styles.nudge_carousel}>
        <div className={styles.headerRow}>
          <Typography.Text className={styles.sectionTitle}>
            Tips & Recommendations
          </Typography.Text>
          {onViewAll && (
            <Typography.Link className={styles.viewAllLink} onClick={onViewAll}>
              View All
            </Typography.Link>
          )}
        </div>
        <NudgeItem
          nudge={nudgeList[0]}
          onclick={() => {
            onNudgeClick(nudgeList[0]);
          }}
        />
      </div>
    );
  }

  return (
    <div className={styles.nudge_carousel}>
      <div className={styles.headerRow}>
        <Typography.Text className={styles.sectionTitle}>
          Tips & Recommendations
        </Typography.Text>
        <div className={styles.rightSection}>
          {onViewAll && (
            <Typography.Link className={styles.viewAllLink} onClick={onViewAll}>
              View All
            </Typography.Link>
          )}
          <div className={styles.arrowButtons}>
            <button className={styles.arrowBtn} onClick={handlePrev}>
              <LeftOutlined />
            </button>
            <button className={styles.arrowBtn} onClick={handleNext}>
              <RightOutlined />
            </button>
          </div>
        </div>
      </div>
      <Carousel
        ref={carouselRef}
        autoplay
        infinite
        dots={false}
        autoplaySpeed={4500}
        speed={500}
        draggable
      >
        {nudgeList.map((nudge) => (
          <NudgeItem
            key={nudge.id}
            nudge={nudge}
            onclick={() => {
              onNudgeClick(nudge);
            }}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default Nudges;
